import React from 'react';
import { useLocation } from 'react-router-dom';
import StatusPage from '../common/StatusPage';
import { useAuthStore } from '../../stores/authStore';

interface RequireAuthProps {
  children: React.ReactNode;
}

export const RequireAuth: React.FC<RequireAuthProps> = ({ children }) => {
  const { user } = useAuthStore();
  const location = useLocation();

  if (!user) {
    const nextPath = `${location.pathname}${location.search}`;
    return (
      <StatusPage
        code={401}
        primaryAction={{
          label: '去登录',
          to: `/login?from=${encodeURIComponent(nextPath)}`,
        }}
      />
    );
  }

  return <>{children}</>;
};
